import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import './styles.css';
import DayEventSelector from './DayEventSelector';

function DateEventSelector({ stateId, selectedSite, selectedSiteName }) {
    const [selectedDate, setSelectedDate] = useState('');
    const [events, setEvents] = useState([]);
    const [selectedImageUrl, setSelectedImageUrl] = useState('');
    const [month, setMonth] = useState([]);
    const [year, setYear] = useState([]);

    //const baseUrl = 'http://127.0.0.1:8000'; // use this if developing locally without using docker, ngrok, or prod enviornments
    const baseUrl = process.env.REACT_APP_API_BASE_URL; //this url should be of load balancer in AWS ECS and http://0.0.0.0:8000 for local

    const handleEventChange = useCallback((eventId) => {
        setSelectedDate(eventId);
        
        if (stateId && selectedSite) {
            // fetch(`${baseUrl}/api/states/${stateId}/sites/${selectedSite}/events/${eventId}`)
            fetch(`${baseUrl}/api/states/${stateId}/sites/${selectedSite}/month_events/${eventId}`)
                .then(response => response.json())
                .then(data => {
                    if (data && data.detected_event) {
                        //setSelectedImageUrl(baseUrl + data.detected_event);
                        setSelectedImageUrl(data.detected_event);
                        const month = moment(data.date).format('MMMM');
                        const year = moment(data.date).year();
                        setMonth(month);
                        setYear(year);
                    }
                    else{
                        setSelectedImageUrl('');
                        setMonth('');
                        setYear('');
                    }
                })
                .catch(error => console.error('Error fetching detected event:', error));
        }
    }, [stateId, selectedSite]);

    useEffect(() => {
        setSelectedImageUrl('');
        setSelectedDate('');
        setEvents([]);
        setMonth([]);
        setYear([]);
    }, [stateId, selectedSite]);

    useEffect(() => {
        if (stateId && selectedSite) {
            // fetch(`${baseUrl}/api/states/${stateId}/sites/${selectedSite}/events/`)
            fetch(`${baseUrl}/api/states/${stateId}/sites/${selectedSite}/month_events/`)
                .then(response => response.json())
                .then(data => {
                    data.sort((a, b) => new Date(b.date) - new Date(a.date));
                    setEvents(data);
                    if (data.length > 0) {
                        setSelectedDate(data[0].id);
                        const selectedData = data.find(item => item.id === data[0].id);
                        const month = moment(selectedData.date).format('MMMM');
                        const year = moment(selectedData.date).year();
                        setMonth(month);
                        setYear(year);
                        handleEventChange(data[0].id);
                    }
                    else {
                        setSelectedDate('');
                        setMonth('');
                        setYear('');
                    }
                })
                .catch(error => console.error('Error fetching sites:', error));
        }
    }, [stateId, selectedSite, handleEventChange]);

    return (
        <div className="site-date-dropdown">
            <div className="heading-button-displays">
                <h2>Selected year: {year}</h2>
                <h2>month: {month}</h2>
                <h2>location: {selectedSiteName}</h2>
            </div>
            {/* <h1>Selected Site: {selectedSiteName}</h1> */}
            <br />
            <br />
            <br />
            <div className="date-container">
                <div className="date-dropdown">
                    <select value={selectedDate} onChange={(e) => handleEventChange(e.target.value)}>
                        <option value="">Select the month</option>
                        {events.map(event => (
                            <option key={event.id} value={event.id}>
                                {moment(event.date).format('MMMM YYYY')}
                            </option>
                        ))}
                    </select>
                    <br />
                    <br />
                </div>
                <div className="max-image">
                    {selectedImageUrl && <img src={selectedImageUrl} alt="" className="max-height-image" />}
                </div>
            </div>
            {stateId && selectedSite && selectedSiteName && month && year && <DayEventSelector stateId={stateId} selectedSite={selectedSite} selectedSiteName={selectedSiteName} month={month} year={year} />}
        </div>
    );
}

export default DateEventSelector;
